import { render, staticRenderFns } from "./collectionLedger.vue?vue&type=template&id=0b65b352&scoped=true"
import script from "./collectionLedger.vue?vue&type=script&lang=js"
export * from "./collectionLedger.vue?vue&type=script&lang=js"
import style0 from "./collectionLedger.vue?vue&type=style&index=0&id=0b65b352&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b65b352",
  null
  
)

export default component.exports